import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserDataApi, withdrawRequestApi } from "../utils/apiHandlers";
import toast from "react-hot-toast";
import { setUserInfo } from "../Redux/WallatSlice";

const Withdrwal = () => {
  const { userinfo, jwt } = useSelector((state) => state.wallet);
  const [amount, setAmount] = useState("");
  const { availableReward } = userinfo;
  const dispatch = useDispatch();

  function refreshData() {
    getUserDataApi(jwt, { email: userinfo?.email, address: userinfo?.user })
      .then(async (res) => {
        if (res?.status == 200) {
          dispatch(setUserInfo(res?.data));
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async function handleRequest() {
    try {
      if (Number(amount) > Number(availableReward)) {
        toast.error("Sorry! insufficient balance");
        return;
      }
      const loginresp = withdrawRequestApi(jwt, amount, "reward");
      const ress = await toast.promise(loginresp, {
        loading: "sending request, please wait...",
        success: () => {},
        error: "login failed",
      });
      if (ress?.status == 400) {
        toast.error(ress?.message);
      } else {
        toast.success(ress?.message);
        refreshData();
      }
      // console.log(ress, " ress");
    } catch (e) {
      console.log(e, "error in withdrawRequest");
    }
  }
  return (
    <>
      <div class="container-fluid align-items-center">
        <div class="row mb-3">
          <div class="col-xl-12">
            {/* <!--<h5 class="card-title text-white">Hi ! 7645823</h5>--> */}
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="mb-2">
              <h4 class="mb-3">Withdrawal</h4>
              <hr />
            </div>

            <div class="table-responsive">
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Wallet Balance
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="walletbalance"
                  aria-describedby=""
                  name="walletbalance"
                  value={(availableReward || 0).toFixed(2)}
                  readonly=""
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Withdrawal Amt
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="withdrawalAmt"
                  aria-describedby=""
                  name="withdrawalAmt"
                  value={amount}
                  onChange={(e) => setAmount(e?.target?.value)}
                />
              </div>

              <div>
                <div className="d-flex justify-content-around align-items-center">
                  <button
                    className="btn btn-warning form-control m-2 fw-bolder w-50"
                    style={{ color: "#000" }}
                    onClick={handleRequest}
                  >
                    Withdrawal
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Withdrwal;
